var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3Bad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 112,
    viewBox: "0 0 168 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9324 80.3882L17.0137 82.493L17.0137 82.493L11.9324 80.3882ZM32.7153 58.994C34.8631 56.8461 34.8631 53.3637 32.7153 51.2158C30.5674 49.0679 27.085 49.0679 24.9371 51.2158L32.7153 58.994ZM11.5001 110.212C11.5001 100.7 13.3736 91.281 17.0137 82.493L6.85105 78.2834C2.65814 88.406 0.500089 99.2553 0.500088 110.212L11.5001 110.212ZM17.0137 82.493C20.6538 73.705 25.9892 65.72 32.7153 58.994L24.9371 51.2158C17.1896 58.9633 11.044 68.1609 6.85105 78.2834L17.0137 82.493Z",
    fill: "#16AA65"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.934 80.3882L150.852 82.493L150.852 82.493L155.934 80.3882ZM135.151 58.994C133.003 56.8461 133.003 53.3637 135.151 51.2158C137.299 49.0679 140.781 49.0679 142.929 51.2158L135.151 58.994ZM156.366 110.212C156.366 100.7 154.493 91.281 150.852 82.493L161.015 78.2834C165.208 88.406 167.366 99.2553 167.366 110.212L156.366 110.212ZM150.852 82.493C147.212 73.705 141.877 65.72 135.151 58.994L142.929 51.2158C150.677 58.9633 156.822 68.1609 161.015 78.2834L150.852 82.493Z",
    fill: "#E25050"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1797 54.7535C36.4626 47.5632 45.0904 41.8777 54.5705 38.0218C64.0506 34.1658 74.1974 32.2148 84.4315 32.2802C94.6656 32.3457 104.787 34.4262 114.217 38.4031C123.647 42.38 132.201 48.1753 139.392 55.4582",
    stroke: "#E2BB50",
    strokeWidth: 11,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3657 108.953L122.298 86.5581C124.334 85.4162 123.097 82.306 120.833 82.8738L76.1124 94.0881C74.9186 94.3875 74.2758 95.684 74.7604 96.8155L79.5489 107.996C80.0169 109.089 81.329 109.534 82.3657 108.953Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Bad);
export default __webpack_public_path__ + "static/media/3-bad.88839e89.svg";
export { ForwardRef as ReactComponent };